<template>
  <fieldset id="payment-information">
    <div class="form-header">
      <h2 class="h4">Payment Information</h2>
      <p>* indicates required field</p>
    </div>
    <div class="form-section">
      <FormField labelText="Confirm the account that benefits will be paid to">
        <DropdownSelect :items="dropDownFormattedMemberList()" v-model="v$.formResponse.member.$model" :initialSelect="dropDownFormattedMemberList()[0].name" />
      </FormField>
    </div>

    <template v-if="selectedMemberAccountDetails !== null">
      <div class="form-section">
        <FormField labelText="BSB" readOnly :required="false">
          <div class="half-width">
            <FormInput readOnly :modelValue="selectedMemberAccountDetails.bsb" />
          </div>
        </FormField>
      </div>

      <div class="form-section">
        <FormField labelText="Account number" readOnly :required="false" :modelValue="selectedMemberAccountDetails.accountNumber" />
      </div>

      <div class="form-section">
        <FormField labelText="Account name" readOnly :required="false" :modelValue="selectedMemberAccountDetails.accountHolderName" />
      </div>
    </template>

    <div class="form-page-nav">
      <section>
        <button class="secondary" @click="updatePage(currentPage - 1)">Back</button>
        <button @click="handleNextPage(currentPage + 1)" :disabled="v$.$invalid || v$.$error">Next</button>
      </section>
    </div>
  </fieldset>
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import AccessLevel from '@/enums/AccessLevel';
import { DropdownSelect } from '@general/js/components';
import GetABenefitQuoteStepsMixin from './GABQnMANC_StepsMixins';

export default {
  setup() { return { v$: useVuelidate() }; },

  name: 'MANC-step-5',

  mixins: [GetABenefitQuoteStepsMixin],

  components: {
    DropdownSelect,
  },

  data() {
    return {
      formResponse: {},
    };
  },

  activated() {
    this.formResponse = this.feature.step5;

    // by default, select member that was selected in step 1.
    this.formResponse.member = this.feature.step1.member;

    // if selected member does not have payment information, default to using the Policy Holder's payment account.
    if (this.selectedMemberAccountDetails === null) {
      // find Policy Holder's person code. always expect api returns access level of each member and person code
      // For child only policy, refData.members don't have policy holder's details, use this.members instead
      this.formResponse.member = this.members.find((member) => {
        return member.accessLevel.toLowerCase() === AccessLevel.POLICY_HOLDER_ACCESS.toLowerCase();
      }).personCode;
    }
  },

  computed: {
    memberList() {
      if (this.refData.accounts) {
        return this.refData.accounts.filter((account) => {
          if (account === null || account.claimsAccount === null) {
            return false;
          }
          // only include members with valid claims account details
          if (!account.keepPrivate) {
            return !this.isEmptyString(account.claimsAccount.accountId) && !this.isEmptyString(account.claimsAccount.bsb) && !this.isEmptyString(account.claimsAccount.accountNumber);
          }
          // EAI only returns claimsAccount.accountId for keep private members
          return !this.isEmptyString(account.claimsAccount.accountId);
        });
      }
      return null;
    },
  },

  methods: {
    dropDownFormattedMemberList() {
      const formattedList = this.memberList.map((member) => {
        return { name: member.firstName, value: member.personCode };
      });

      return formattedList;
    },
  },

  validations: {
    formResponse: {
      member: {
        required,
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.half-width {
  width: calc(50% - 7.5px);

  @include mobile {
    width: 100%;
  }
}

.form-header {
  margin-bottom: 48px;

  h2 {
    margin-bottom: 0.25rem;
  }

  p {
    margin-bottom: 0;
  }
}
</style>
